/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2019 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/

/**
 * Returns a landing page redirect based on response from server and current URL
 * @param {Object=} landingPageResponse Response from IMSSSOhandler.
 * @param {string} redirectLocation Where the server believes the user should be redirected.
 * @returns {string} A string of a path, or empty for no-redirect.
 */
export function getLandingPageRedirect(landingPageResponse) {
  let landingPageUrlString = landingPageResponse && landingPageResponse.redirectLocation;
  if (!landingPageUrlString) {
    return '';
  }

  const landingPageUrl = new URL(landingPageUrlString);
  // Identify if the redirect location is a route in exc-app or an external page.
  // Check to be improved further. Currently validating against first level route.
  if (landingPageUrl.origin === window.location.origin) {
    let parts = landingPageUrl.href.split('#');
    return parts.length > 1 ? parts.slice(1).join('#') : '';
  }

  // If user's landing page is ExC Home, take user to Unified Shell Home
  if (landingPageUrl.hostname.startsWith('exc-home') && landingPageUrl.pathname.startsWith('/exc-home/home')) {
    return '/home';
  }

  window.location.assign(landingPageUrl.href);
}
